import ApiClient from './ApiClient';

// Surfaces backend structured errors ({ error: "..." }) — mirrors TasksClient/ColoClient.
const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback;

const toCamelKey = key => key.charAt(0).toLowerCase() + key.slice(1);

const toCamelCaseShallow = obj => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [toCamelKey(key), value])
  );
};

class SettingsClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}/settings` : '/settings');
  }

  async getDunningSettings() {
    try {
      const data = await this.get('/dunning');
      return toCamelCaseShallow(data?.settings);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to fetch dunning settings.')
      );
    }
  }

  // body: { enabled, graceDays }
  async updateDunningSettings(body) {
    try {
      const data = await this.put('/dunning', body);
      return toCamelCaseShallow(data?.settings);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to update dunning settings.')
      );
    }
  }
}

export default SettingsClient;
